export default __webpack_public_path__ + "static/titleIcon-baa41ce89c92251d8cef53d6f5de23aa.svg";